var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_103_94)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 7.5C40.0754 7.5 35.1991 8.46997 30.6494 10.3545C26.0997 12.2391 21.9657 15.0013 18.4835 18.4835C11.4509 25.5161 7.5 35.0544 7.5 45C7.5 61.575 18.2625 75.6375 33.15 80.625C35.025 80.925 35.625 79.7625 35.625 78.75V72.4125C25.2375 74.6625 23.025 67.3875 23.025 67.3875C21.3 63.0375 18.8625 61.875 18.8625 61.875C15.45 59.55 19.125 59.625 19.125 59.625C22.875 59.8875 24.8625 63.4875 24.8625 63.4875C28.125 69.1875 33.6375 67.5 35.775 66.6C36.1125 64.1625 37.0875 62.5125 38.1375 61.575C29.8125 60.6375 21.075 57.4125 21.075 43.125C21.075 38.9625 22.5 35.625 24.9375 32.9625C24.5625 32.025 23.25 28.125 25.3125 23.0625C25.3125 23.0625 28.4625 22.05 35.625 26.8875C38.5875 26.0625 41.8125 25.65 45 25.65C48.1875 25.65 51.4125 26.0625 54.375 26.8875C61.5375 22.05 64.6875 23.0625 64.6875 23.0625C66.75 28.125 65.4375 32.025 65.0625 32.9625C67.5 35.625 68.925 38.9625 68.925 43.125C68.925 57.45 60.15 60.6 51.7875 61.5375C53.1375 62.7 54.375 64.9875 54.375 68.475V78.75C54.375 79.7625 54.975 80.9625 56.8875 80.625C71.775 75.6 82.5 61.575 82.5 45C82.5 40.0754 81.53 35.1991 79.6455 30.6494C77.7609 26.0997 74.9987 21.9657 71.5165 18.4835C68.0343 15.0013 63.9003 12.2391 59.3506 10.3545C54.8009 8.46997 49.9246 7.5 45 7.5Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_103_94",
    x: -4,
    y: 0,
    width: 98,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0 0.621667 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_103_94"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_103_94",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.c1cb8892e0b1d2004b93275c69be4d15.svg";
export { ForwardRef as ReactComponent };